import { useTranslation } from "react-i18next"
import { DisableWheelHouseWrapper } from "./styles"
import CustomButton from "@Common/CustomButton"
import WheelHouseLarge from "@assets/svg/wheelHouse_large.svg?react"
import { IoClose } from "react-icons/io5"
import { useContext, useState } from "react"
import { APIS_KEYS, usePutAutomationWheelhouseProperties } from "@services"
import { IResponseGetWheelhouseProperties } from "src/services/calender/getWheelhouseProperties/types"
import { ToastMessageContext } from "@context/toast-message-cotnext"
import { useQueryClient } from "@tanstack/react-query"

interface IProps {
	closePopUp: () => void
	dataWheelhouseProperties: IResponseGetWheelhouseProperties | undefined
	refetch: () => void
}
export default function DisableWheelHouse({ closePopUp, dataWheelhouseProperties, refetch }: IProps) {
	const { t } = useTranslation()
	const { showSuccess, showError } = useContext(ToastMessageContext)
	const queryClient = useQueryClient()
	const [isLoading, setIsLoading] = useState(false)

	/* ---------------------------------- API'S --------------------------------- */
	const { mutateAsync } = usePutAutomationWheelhouseProperties()

	/* ----------------------------- Handle Disable ----------------------------- */
	const handleDisableWheelhouse = async () => {
		setIsLoading(true)

		// Create payload with all properties set to enabled: false
		const payload =
			dataWheelhouseProperties?.result.map((item) => ({
				listingId: String(item.propertyId),
				enabled: false, // Disable all properties
			})) || []

		try {
			const res = await mutateAsync(payload)
			if (res.status === 200) {
				showSuccess(t("WebsiteBuilder.SettingsModified"))
				queryClient.invalidateQueries({ queryKey: [APIS_KEYS.GETCALENDERDATA] })
				refetch()
				closePopUp()
			}
		} catch (error) {
			console.error("Error disabling wheelhouse:", error)
			showError(t("COMMON.SOMETHING_WENT_WRONG") || "Failed to disable wheelhouse")
		} finally {
			setIsLoading(false)
		}
	}
	return (
		<DisableWheelHouseWrapper>
			<div>
				<div onClick={() => closePopUp()}>
					<IoClose />
				</div>
				<div>
					<WheelHouseLarge />
				</div>
				<div>{t("CALENDAR.do_you_want_to_stop_wheel_house")}</div>
				<div>
					<CustomButton
						label={t("CALENDAR.stop")}
						customPadding='16px 24px'
						customBG='#5B3FFF'
						customColor='#fff'
						type='button'
						onClick={handleDisableWheelhouse}
						loading={isLoading}
					/>
				</div>
			</div>
		</DisableWheelHouseWrapper>
	)
}
